import { apiFetch } from '../apiFetch'

export const startQuest = (questId, saveId) =>
  apiFetch({
    path: '/quest_progress',
    method: 'POST',
    payload: { quest_id: questId, dungeon_save_id: saveId || undefined },
  })

export const completeQuestStep = (questId, stepId) =>
  apiFetch({
    path: `/quest_progress/${questId}/step`,
    method: 'PUT',
    payload: { step_id: stepId },
  })

export const completeQuest = (questId) =>
  apiFetch({
    path: `/quest_progress/${questId}/complete`,
    method: 'PUT',
    payload: {},
  })

export const getQuestProgress = (dungeonSlug) =>
  apiFetch({
    path: `/quest_progress${dungeonSlug ? `?dungeon_slug=${dungeonSlug}` : ''}`,
  })
